var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _g2, _circle2, _rect6, _rect7, _g3, _path, _path2, _rect8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDashboard = function SvgDashboard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 276,
    viewBox: "0 0 376 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.42,
    cx: 189.409,
    cy: 137.558,
    r: 137.558,
    fill: "#C5CEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_50129)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.633,
    y: 129.249,
    width: 102.699,
    height: 101.188,
    rx: 15.1027,
    transform: "rotate(6.93384 261.633 129.249)",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 272.979,
    y: 161.056,
    width: 5.28596,
    height: 55.125,
    rx: 2.64298,
    transform: "rotate(6.93384 272.979 161.056)",
    fill: "#C3E3FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 285.914,
    y: 192.296,
    width: 5.28596,
    height: 25.6746,
    rx: 2.64298,
    transform: "rotate(6.93384 285.914 192.296)",
    fill: "#C3E3FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 304.775,
    y: 174.812,
    width: 5.28596,
    height: 45.3082,
    rx: 2.64298,
    transform: "rotate(6.93384 304.775 174.812)",
    fill: "#C3E3FC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 321.998,
    y: 170.821,
    width: 5.28596,
    height: 51.3493,
    rx: 2.64298,
    transform: "rotate(6.93384 321.998 170.821)",
    fill: "#79C4FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 336.119,
    y: 192.316,
    width: 5.28596,
    height: 31.7157,
    rx: 2.64298,
    transform: "rotate(6.93384 336.119 192.316)",
    fill: "#79C4FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2_50129)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 62.2961,
    width: 174.024,
    height: 58.5657,
    rx: 16.7331,
    transform: "rotate(-7.46195 14 62.2961)",
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.1783,
    cy: 87.7458,
    r: 14.2231,
    transform: "rotate(-7.46195 45.1783 87.7458)",
    fill: "#C3E3FC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69.4824,
    y: 73.5938,
    width: 24.2629,
    height: 7.52988,
    rx: 3.76494,
    transform: "rotate(-7.46195 69.4824 73.5938)",
    fill: "#79C4FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 71.2207,
    y: 87.5959,
    width: 56.0558,
    height: 7.52988,
    rx: 3.76494,
    transform: "rotate(-7.46195 71.2207 87.5959)",
    fill: "#C3E3FC"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_2_50129)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.5488,
    y: 72.9333,
    width: 192.027,
    height: 130.172,
    rx: 18.4641,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.166 138.021C131.708 138.021 129.4 119.557 151.557 118.633C173.714 117.71 177.406 150.022 194.947 150.022C212.488 150.022 219.412 101.554 266.496 101.554",
    stroke: "#C6E4FC",
    strokeWidth: 2.76961
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M151.557 118.633C129.4 119.557 131.708 138.021 108.166 138.021V162.486H266.496V101.554C219.412 101.554 212.488 150.022 194.947 150.022C177.406 150.022 173.714 117.71 151.557 118.633Z",
    fill: "url(#paint0_linear_2_50129)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 108.166,
    y: 173.564,
    width: 52.6227,
    height: 10.1553,
    rx: 5.07763,
    fill: "#79C4FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_50129",
    x: 237.536,
    y: 124.164,
    width: 137.925,
    height: 136.609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.79623
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.79623
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.47451 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_50129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2_50129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2_50129",
    x: 0.969541,
    y: 34.1957,
    width: 206.217,
    height: 106.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.52988
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.52988
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.47451 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_50129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2_50129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_2_50129",
    x: 70.3151,
    y: 59.0853,
    width: 234.495,
    height: 183.718,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.4641
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.6169
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.47451 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_50129"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.76961
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.53923
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.509184 0 0 0 0 0.566595 0 0 0 0 0.879167 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2_50129",
    result: "effect2_dropShadow_2_50129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2_50129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_50129",
    x1: 187.331,
    y1: 109.402,
    x2: 187.331,
    y2: 162.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6E4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDashboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dashboard.06fe877cd4eb7c3d148ae530ee16079f.svg";